module.exports = __webpack_public_path__ + "images/category_lp/furniture/store_images/1@2x_6d2f0a18490375fd24b5558c1fdf5c34.png";